import clsx from 'clsx'
import styles from './Spinner.module.scss'

interface SpinnerProps {
  size?: 'default' | 'small'
  className?: string
}

export function Spinner({ size = 'default', className }: SpinnerProps): React.JSX.Element {
  return (
    <span
      className={clsx(
        styles.loader,
        size === 'small' && 'h-6 w-6 border-[2px] after:border-[2px]',
        size === 'default' && 'h-10 w-10 border-[3px] after:border-[3px]',
        className
      )}
    />
  )
}
